import React, { useState, useEffect, useCallback } from 'react';
import {
  Card,
  CardContent,
  Grid,
  Typography,
  Button,
  FormHelperText,
} from '@mui/material';
import { Delete as DeleteIcon, Send as SendIcon } from '@mui/icons-material';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { Form } from 'react-final-form';

import { Content } from '../layout';
import { Radio, TextField } from '../common/Fields';
import { targets } from './types';

import {
  getMessage,
  submitMessage,
  updateMessage,
  deleteMessage,
  fetchMessageMacros,
} from '../../actions';

const MessageForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  const { message } = useSelector((state) => state.message);
  const messageMacros = useSelector((state) => state.messageMacro.data?.rows);
  const { messageMacro } = useSelector((state) => state.messageMacro);

  const [target, setTarget] = useState('0');
  const [isUrgent, setIsUrgent] = useState(false);
  const [MessageMacroId, setMessageMacroId] = useState();
  const [subject, setSubject] = useState('');
  const [content, setContent] = useState('');

  useEffect(() => {
    dispatch(fetchMessageMacros());
    if (id) {
      // console.log("id", id);
      dispatch(getMessage(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    if (message) {
      // console.log("message", message);
      // console.log(
      //   "String(message.MessageMacro.id)",
      //   message.MessageMacro.id.toString()
      // );
      setTarget(String(message.target));
      setIsUrgent(message.isUrgent);
      setMessageMacroId(message.MessageMacro.id);
      setSubject(message.MessageMacro.subject);
      setContent(message.MessageMacro.content);
    }
  }, [message]);

  useEffect(() => {
    if (messageMacro) {
      console.log('messageMacro', messageMacro);
      setSubject(messageMacro.subject);
      setContent(messageMacro.content);
    }
  }, [messageMacro]);

  // useEffect(() => {
  //   if (MessageMacroId === null) {
  //     if (messageMacros && messageMacros.length > 0) {
  //       // setMessageMacroId(String(messageMacros[0].id));
  //       setMessageMacroId(messageMacros[0].id);
  //     }
  //   }
  // }, [MessageMacroId, messageMacros]);

  const handleChangeTarget = (event) => {
    setTarget(String(event.target.value));
  };

  const handleChangeIsUrgent = (event) => {
    setIsUrgent(JSON.parse(event.target.value));
  };

  const handleChangeMessageMacro = (event) => {
    event.preventDefault();
    const targetValue = Number(event.target.value);
    setMessageMacroId(targetValue);
    // console.log("messageMacros", messageMacros);
    const { subject, content } = messageMacros.find(
      (macro) => macro.id === targetValue
    );
    setSubject(subject);
    setContent(content);
    // dispatch(getMessageMacro(event.target.value));
  };

  const onSubmit = useCallback(
    (message) => {
      // const message = {
      //   target,
      //   isUrgent,
      //   MessageMacroId,
      // };
      console.log('message on submit', message);
      if (id) {
        dispatch(updateMessage({ message, id }, navigate));
      } else {
        dispatch(submitMessage({ message }, navigate));
      }
    },
    [id, dispatch, navigate]
  );

  const onDelete = useCallback(
    (e) => {
      e.preventDefault();
      dispatch(deleteMessage({ id }, navigate));
    },
    [id, dispatch, navigate]
  );

  return (
    <Form
      onSubmit={onSubmit}
      initialValues={{
        target,
        isUrgent,
        MessageMacroId,
      }}
      validate={(values) => {
        const errors = {};
        return errors;
      }}
      render={({ submitError, handleSubmit, submitting, pristine, values }) => (
        <Content>
          <form onSubmit={handleSubmit} style={{ flexGrow: 1 }}>
            <Card>
              <CardContent>
                <Typography variant="h5" component="div">
                  메시지
                </Typography>

                <Grid
                  container
                  alignItems="flex-start"
                  spacing="20"
                  sx={{ mt: 2 }}
                >
                  <Grid item xs={12}>
                    <Radio
                      label="대상"
                      name="target"
                      radioGroupProps={{
                        row: true,
                      }}
                      data={targets}
                      dataKey="id"
                      dataValue="name"
                      onChange={handleChangeTarget}
                      // checkedValue={target}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Radio
                      label="긴급 여부"
                      name="isUrgent"
                      radioGroupProps={{
                        row: true,
                      }}
                      data={[
                        { id: false, name: '일반' },
                        { id: true, name: '긴급' },
                      ]}
                      dataKey="id"
                      dataValue="name"
                      onChange={handleChangeIsUrgent}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Radio
                      label="매크로"
                      name="MessageMacroId"
                      radioGroupProps={{
                        row: true,
                      }}
                      data={messageMacros}
                      dataKey="id"
                      dataValue="macroId"
                      // helperText={helperText}
                      onChange={handleChangeMessageMacro}
                      // checkedValue={messageMacroId}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      variant="standard"
                      name="subject"
                      type="text"
                      label="제목"
                      value={subject}
                      readOnly
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      variant="standard"
                      name="content"
                      type="text"
                      label="내용"
                      value={content}
                      readOnly
                    />
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
            {submitError && <FormHelperText>{submitError}</FormHelperText>}
            <Grid container sx={{ mt: 2 }}>
              <Grid item xs={6}>
                {id && (
                  <Button
                    variant="outlined"
                    color="error"
                    startIcon={<DeleteIcon />}
                    onClick={onDelete}
                  >
                    삭제
                  </Button>
                )}
              </Grid>
              <Grid item xs={6} container justifyContent="flex-end">
                <Button
                  variant="contained"
                  endIcon={<SendIcon />}
                  type="submit"
                >
                  저장
                </Button>
              </Grid>
            </Grid>
          </form>
        </Content>
      )}
    />
  );
};

export default MessageForm;
